import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var MessageChatCircle = function MessageChatCircle(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M6.0944 11.2288A8 8 0 0 1 6 10c0-4.4183 3.6053-8 8.0526-8s8.0526 3.5817 8.0526 8c0 .9981-.1839 1.9535-.52 2.8345-.0698.183-.1048.2745-.1206.3459a.9.9 0 0 0-.0235.1931c-.0017.0731.0082.1537.0281.3148l.4025 3.2702c.0436.354.0654.531.0065.6597a.5.5 0 0 1-.2571.2513c-.13.0559-.3065.03-.6594-.0217l-3.1852-.4669c-.1664-.0244-.2495-.0366-.3253-.0361a.9.9 0 0 0-.2001.0213c-.0741.0156-.1688.0511-.3581.122-.8833.3309-1.8406.5119-2.8404.5119a8.2 8.2 0 0 1-1.2299-.0927M7.6316 22C10.5965 22 13 19.5376 13 16.5S10.5965 11 7.6316 11s-5.3684 2.4624-5.3684 5.5c0 .6106.097 1.1979.2764 1.7467.0757.232.1136.348.126.4272a.85.85 0 0 1 .0105.2128c-.0046.0801-.0247.1706-.0648.3516L2 22l2.9948-.409c.1635-.0223.2452-.0335.3166-.033a.84.84 0 0 1 .1887.0193c.07.0139.174.0506.3822.1241A5.25 5.25 0 0 0 7.6316 22"
    })
  }));
};
export default MessageChatCircle;